import React from "react";
import { Modal } from "@mui/material";
import moment from "moment";

import Icon from "../../../assets/appointment-checked.svg";
import "./component-styles.scss";

export default function AppointmentJoinModal(props) {
  function handleYesClick() {
    props.closeView();
    props.joinVideoCallback();
  }
  return (
    <>
      {props.openView ? (
        <Modal
          open={props.openView}
          onClose={props.closeView}
          dialogClassName="close-ongoing-consult"
        >
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className="appointment-join-modal-wrapper">
            <div className="d-flex flex-column justify-content-center align-items-center appointment-modal-container">
              <img src={Icon} alt="success" />
              <h4
                className="text-center mt-3 font-weight-bold"
                style={{ font: "font: normal normal medium 24px/29px Rubik" }}
              >
                Start Consultation
              </h4>
              <div className="text-center my-2">
                Patient Name :{" "}
                <b className="text-capitalize">
                  {props?.appointment?.patient_name || "-"}
                </b>
              </div>
              <div className="text-center my-1 appointment-time-container">
                <span>Appointment Scheduled Time :</span>
                <b className="ml-1">
                  {props?.appointment?.appointment_start_time
                    ? moment(
                        props?.appointment?.appointment_start_time,
                        "hh:mm:ssZ"
                      ).format("hh:mm A")
                    : null}
                  {props?.appointment?.appointment_date
                    ? " on " +
                      moment(props?.appointment?.appointment_date).format(
                        "DD MMM, YYYY"
                      ) +
                      "."
                    : null}
                </b>
                {/* &nbsp;with Patient {props.patient_name}. */}
              </div>
              <p className="text-center my-1 consultation-note">
                {/* Once you join, this appointment will be marked as success and
                you will not be able to join again. */}
                You can put the call on hold and rejoin later if you feel the
                need during the consultation.
              </p>
              {/* <p className="text-center my-2 font-weight-bold">
                Do you still want to continue?
              </p> */}
              <div className="justify-content-center my-3 action-container">
                <button
                  className="btn primary-cta-button rounded-pill action-buttons mr-3"
                  onClick={handleYesClick}
                >
                  Yes
                </button>
                <button
                  className="btn secondary-button rounded-pill action-buttons"
                  onClick={props.closeView}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
        </Modal>
      ) : null}
    </>
  );
}
